<template>
  <p v-if="lead && lead.text" class="headline-lead" :inner-html.prop="lead.text | truncate(maxChars)" />
</template>
<script lang="ts">
import Vue from 'vue';
import { truncate } from '@core/filters/htmlFormater';
import { Headline } from '@headlines/types/headline';

interface Props {
  lead: Headline['content']['lead'];
  maxChars: number;
}

export default Vue.extend<unknown, unknown, unknown, Props>({
  name: 'HeadlineLead',
  filters: {
    truncate,
  },
  props: {
    lead: {
      type: Object,
      required: true,
    },
    maxChars: {
      type: Number,
      required: false,
      default: 300,
    },
  },
});
</script>
<style lang="scss">
.headline-lead {
  font-size: 13px;
  color: get-color('grey-1');
  margin: 12px 0;
  line-height: 1.77;
}
</style>
